import { render, staticRenderFns } from "./ProfilePreview.vue?vue&type=template&id=01658f6e"
import script from "./ProfilePreview.vue?vue&type=script&lang=js"
export * from "./ProfilePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports